export default __webpack_public_path__ + "static/7-db5966d5d93e1e70746685bd71fae95f.webp";